import { render, staticRenderFns } from "./ChooseCustomers.vue?vue&type=template&id=5c40d096&"
import script from "./ChooseCustomers.vue?vue&type=script&lang=js&"
export * from "./ChooseCustomers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports